import React, { useEffect } from "react";
import ExpandableCard from "../../Components/ExpandableCard/ExpandableCard";
import Data from "../../Assets/Content/ContentData.js"; // Import ContentData for links

const AIPage = (props) => {
  useEffect(() => {
    document.title = "Kreislaufwirtschafts-Guide | Künstliche Intelligenz";
  }, []);

  const handleNavClick = (e, viewName, cardKey = null) => {
    e.preventDefault();
    if (props.onChangeView) {
      props.onChangeView(viewName, cardKey);
    }
  };

  const cardsData = [
    {
      title: "Künstliche Intelligenz und Kreislaufwirtschaft",
      image:
        "data:image/svg+xml;charset=UTF-8,%3Csvg width='600' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='600' height='400' fill='%23eeeeee'/%3E%3C/svg%3E",
      jsxContent: (
        <>
          <p>
            Künstliche Intelligenz (KI) umfasst Algorithmen, die aus Daten
            lernen, Muster erkennen und Entscheidungen oder Vorhersagen treffen.
            In der Kreislaufwirtschaft unterstützt KI nachhaltiges Design,
            vorausschauende Wartung, optimierte Produktions- und Absatzplanung
            sowie automatisierte Sortierung und Recycling. Chancen sind
            Ressourceneinsparung, längere Nutzungsdauern und neue zirkuläre
            Geschäftsmodelle. Gleichzeitig entstehen ökologische und soziale
            Risiken: hoher Energiebedarf großer Modelle, Datenschutz- und
            Ethikfragen, Zielkonflikte und Rebound-Effekte. Ergänzend wichtige
            Technologien sind Internet of Things (IoT), Big Data Analytics,
            Datenräume und Digitale Produktpässe, Blockchain, additive
            Fertigung, Rücknahmesysteme und B2B-Plattformen.
          </p>
          <p>
            Schauen Sie sich jede{" "}
            <a
              href="#"
              onClick={(e) => handleNavClick(e, "Intro")}
              style={{ color: "#b80900", fontWeight: "bold" }}
            >
              Produktlebenszyklusphase
            </a>{" "}
            an und identifizieren Sie, wie KI dort konkret eingesetzt werden
            kann.
          </p>
        </>
      ),
    },
    {
      title: "Praxisbeispiel zu KI Anwendungen",
      image: null, // No image -> Full width content
      jsxContent: (
        <div>
          <p>
            Anhand konkreter Praxisbeispiele lässt sich das Potenzial von KI in
            der Kreislaufwirtschaft verdeutlichen. Die folgende Übersicht zeigt
            Unternehmen verschiedener Branchen, welche in den jeweiligen Phasen
            des Kreislaufs innovative KI-Lösungen einsetzen.
          </p>
          <div className="table-responsive">
            <table className="table table-striped table-hover mt-3">
              <thead style={{ backgroundColor: "#b80900", color: "white" }}>
                <tr>
                  <th scope="col">Unternehmen</th>
                  <th scope="col">Branche</th>
                  <th scope="col">Phase</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a
                      href={Data.Rohstoffe.example.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      BBM Maschinenbau
                    </a>
                  </td>
                  <td>Anlagen- und Maschinenbau</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "Rohstoffe")}
                      style={{ color: "#b80900" }}
                    >
                      Rohstoffe
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href={Data.EcoDesign.example.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      VEKA AG
                    </a>
                  </td>
                  <td>Baubranche / Fensterprofile</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "EcoDesign")}
                      style={{ color: "#b80900" }}
                    >
                      Eco Design
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href={Data.Produktion.examples[0].link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      Gestalt Robotics GmbH
                    </a>
                  </td>
                  <td>Automatisierung / Pharma</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "Produktion")}
                      style={{ color: "#b80900" }}
                    >
                      Produktion
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href={Data.Produktion.examples[1].link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      C. Jentner GmbH
                    </a>
                  </td>
                  <td>Galvanotechnik</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "Produktion")}
                      style={{ color: "#b80900" }}
                    >
                      Produktion
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href={Data.Produktion.examples[2].link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      Alfred Willich Produktions GmbH
                    </a>
                  </td>
                  <td>Lebensmittelindustrie</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "Produktion")}
                      style={{ color: "#b80900" }}
                    >
                      Produktion
                    </a>
                  </td>
                </tr>
                {/* Vertrieb example has no link in ContentData snippet above, just text? 
                    Checking ContentData: Vertrieb.example has text and title 'Logistikbranche', 
                    does NOT seem to have a link property in the file snippet I read. 
                    I'll leave it as text for now or verify if I missed it.
                    Wait, let me check the file read output again carefully.
                    Vertrieb: example: { title: "Logistikbranche", text: "..." } -> NO LINK.
                    So I cannot link it externally. I'll just keep the text bold if desired or plain.
                */}
                <tr>
                  <td>
                    <span style={{ fontWeight: "bold" }}>
                      Logistikbranche (Allgemein)
                    </span>
                  </td>
                  <td>Logistik</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "Vertrieb")}
                      style={{ color: "#b80900" }}
                    >
                      Vertrieb
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href={Data.Nutzung.example.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      juS.TECH AG
                    </a>
                  </td>
                  <td>Sicherheitslösungen / Bahn</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "Nutzung")}
                      style={{ color: "#b80900" }}
                    >
                      Nutzung
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href={Data.Nutzungsende.example.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      Circular Digital Economy Lab 2.0
                    </a>
                  </td>
                  <td>Umwelttechnik</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) =>
                        handleNavClick(e, "Intro", "Nutzungsende")
                      }
                      style={{ color: "#b80900" }}
                    >
                      Nutzungsende
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href={Data.Recycling.example.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#b80900", fontWeight: "bold" }}
                    >
                      Smart Recycling Up
                    </a>
                  </td>
                  <td>Recycling / Abfallwirtschaft</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => handleNavClick(e, "Intro", "Recycling")}
                      style={{ color: "#b80900" }}
                    >
                      Recycling
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <h5 style={{ color: "black" }}>Weiterführende Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a
                  href="https://www.mittelstand-digital-wertnetzwerke.de/fileadmin/user_upload/Materialien/Wissensbox/mittelstand-digital-zentrum-wertnetzwerke-material-KI-anwendungsbeispiele.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#b80900", textDecoration: "underline" }}
                >
                  Link zu Anwendungsbeispielen (Übersichtstabelle CSCP)
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://www.prosperkolleg.de/wissen-publikationen/aus-der-praxis/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#b80900", textDecoration: "underline" }}
                >
                  Praxisbeispiele Circular Economy - Prosperkolleg
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://www.efa.nrw/fuer-unternehmen/praxisbeispiele"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#b80900", textDecoration: "underline" }}
                >
                  Praxisbeispiele - efa NRW
                </a>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="container mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          {cardsData.map((card, index) => (
            <ExpandableCard
              key={index}
              title={card.title}
              content={card.content}
              image={card.image}
              initiallyOpen={index === 0}
            >
              {card.jsxContent}
            </ExpandableCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIPage;
